import { useEffect } from 'react';

import { Card } from '@zillow/constellation-10';
import { zillowWebLogin } from '@zillow/auth-core';

type Props = { redirectUrl?: string };

const redirectsToAuth0Login = (redirectUrl: string) => {
  zillowWebLogin({
    loginMode: 'redirect',
    trackingConfig: {
      entryPoint: 'rental-manager-login',
    },
    oauthOptions: {
      loginHint: undefined,
    },
    uiConfig: {},
    ...{ redirectUri: redirectUrl },
  });
};

const ZillowWebLogin = ({ redirectUrl = '/rental-manager/properties' }: Props) => {
  useEffect(() => {
    redirectsToAuth0Login(redirectUrl);
  }, [redirectUrl]);

  return (
    <Card data-testid="ZillowWebLogin" tone="neutral" elevated={false} css={{ margin: 'auto' }}>
      Redirecting to auth0...
    </Card>
  );
};

export default ZillowWebLogin;
